import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide
} from '@material-ui/core'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import {
  resourceWorkAssignmentAuditCols,
  resourceWorkAssignmentAuditFieldsCols
} from '../constants/ResourceCols'
import { dateFormat } from '../utils/formatter'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function CandidateAuditLog(props) {
  const { headers, tableRefreshKey, linkedEmployee } = props

  const [fieldsDialog, setFieldsDialog] = useState({
    isOpen: false,
    recordHistoryId: null
  })

  const tableDataTransformation = rows => {
    return rows.map(row => ({
      ...row,
      Effective_dt_link: (
        <div
          className='editLink'
          onClick={() => setFieldsDialog({ isOpen: true, recordHistoryId: row.RECORD_HISTORY_ID })}
        >
          {dateFormat(row.EFFECTIVE_DT)}
        </div>
      )
    }))
  }

  return (
    <div>
      <Dialog
        open={fieldsDialog.isOpen}
        TransitionComponent={Transition}
        maxWidth='xl'
        scroll='body'
        keepMounted
        onClose={() => setFieldsDialog({ isOpen: false, recordHistoryId: null })}
      >
        <DialogTitle>Field Changes</DialogTitle>
        <DialogContent>
          {fieldsDialog.recordHistoryId && (
            <DashboardAthenaTable
              {...props}
              isTempTable={false}
              key={fieldsDialog.recordHistoryId}
              params={{ recordHistoryId: fieldsDialog.recordHistoryId }}
              tableColumns={resourceWorkAssignmentAuditFieldsCols}
              reportName='hr_resource_audit_fields'
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            onClick={() => setFieldsDialog({ isOpen: false, recordHistoryId: null })}
            className='primaryVLButton'
            variant='contained'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <DashboardAthenaTable
        {...props}
        isTempTable={false}
        key={`audit-log-${tableRefreshKey}`}
        params={{ hrOrg: headers.hrOrg, employee: linkedEmployee }}
        tableColumns={resourceWorkAssignmentAuditCols}
        reportName='hr_resource_audit'
        transform={tableDataTransformation}
      />
    </div>
  )
}
